export default "__VITE_ASSET__B0t3NRn3__"